import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { ICON_HEIGHT_16, IconWithTooltip } from '../../../../../Icon'
import { TableCellBase } from '../../../../../Table'
import { getIsApplicantProfileEmailMasked } from '../../RentalPortalApplicantProfileEmails.utils'

import { ApplicantProfileEmailsMaskedMessage } from './ApplicantProfileEmailsMaskedMessage'
import { ApplicantProfileEmailsMessage } from './ApplicantProfileEmailsMessage'

import * as styles from './ApplicantProfileEmailsMessageCell.module.css'

import AttachIcon from '../../../../../../icons/attach.svg'

function ApplicantProfileEmailsMessageCell({ item, ...restProps }) {
  const { t } = useTranslation()

  return (
    <TableCellBase
      {...restProps}
      className={styles.ApplicantProfileEmailsMessageCell}
    >
      {getIsApplicantProfileEmailMasked(item) ? (
        <ApplicantProfileEmailsMaskedMessage />
      ) : (
        <ApplicantProfileEmailsMessage item={item} />
      )}
      {item.has_attachments ? (
        <IconWithTooltip
          Icon={AttachIcon}
          className={styles.attachment}
          size={ICON_HEIGHT_16}
          tooltip={t('Common.AttachedFilesTagTextKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
        />
      ) : null}
    </TableCellBase>
  )
}

export default ApplicantProfileEmailsMessageCell
